import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ApplicationState } from "@/store";

import { AccessTab, StoreAccessFilterState, TabFilters } from "../types";

export const useStoreAccessFilterState = (): StoreAccessFilterState =>
  useSelector((state: ApplicationState) => state.storeAccessFilter);

/**
 * Atalho para consumidores que só precisam dos filtros da tab ativa — evita
 * boilerplate de `const tab = activeTab; const f = state[tab];`.
 *
 * Deps explícitos (ao invés do objeto `state` inteiro) para que atualizações
 * em `storeHealth` (volátil, alta frequência) não invalidem o memo à toa.
 */
export const useActiveTabFilters = (): {
  tab: AccessTab;
  filters: TabFilters;
  storeCode: number | null;
} => {
  const state = useStoreAccessFilterState();
  return useMemo(
    () => ({
      tab: state.activeTab,
      filters: state[state.activeTab],
      storeCode: state.storeCode,
    }),
    [state.activeTab, state.users, state.operators, state.storeCode],
  );
};
